module.exports = __webpack_public_path__ + "static/media/circleFrame5.c951df20.svg";